var map = {
	"./atlantic.svg": 8570,
	"./barilla.svg": 149,
	"./dr_oetker.svg": 6514,
	"./leone.png": 3277,
	"./pernot_ricard.svg": 1970,
	"./petrol.svg": 6695,
	"./podravka.svg": 7634,
	"./renault_group.svg": 1463,
	"./rittal.png": 4409,
	"./spar.svg": 1300,
	"./storck.svg": 5193,
	"./vaillant.svg": 262
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1839;